import { Form, Tabs } from 'antd';
import type {
  MaintenancePartnershipValidity,
  MaintenanceSlaScopeOptions,
} from '~/app/landing/sla/oems/components/MaintenanceSlaContract/types';
import type { MaintenanceSlaContractState } from '~/app/landing/sla/oems/components/MaintenanceSlaContract/hooks/useMaintenanceSlaContract';
import { useMaintenanceSlaContractFormTabs } from '~/app/landing/sla/oems/components/MaintenanceSlaContract/hooks/useMaintenanceSlaContractFormTabs';

export interface MaintenanceSlaContractFormProps {
  partnership: MaintenancePartnershipValidity;
  state: MaintenanceSlaContractState;
  scopeOptions: MaintenanceSlaScopeOptions;
  scopeOptionsLoading: boolean;
}

export function MaintenanceSlaContractForm({
  partnership,
  state,
  scopeOptions,
  scopeOptionsLoading,
}: MaintenanceSlaContractFormProps) {
  const tabProps = useMaintenanceSlaContractFormTabs({
    partnership,
    draft: state.draft,
    state,
    scopeOptions,
    scopeOptionsLoading,
    showValidation: state.showErrors,
    allIssues: state.issues,
  });

  if (!state.draft) {
    return null;
  }

  return (
    <Form layout="vertical" component="div" className="sla-modal-form">
      <Tabs {...tabProps} />
    </Form>
  );
}
